import { render, staticRenderFns } from "./HealthIssues.vue?vue&type=template&id=1706080f"
import script from "./HealthIssues.vue?vue&type=script&lang=js"
export * from "./HealthIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports